'use strict';

var react = require('react');
const BACKSPACE = 'deleteContentBackward';
const DELETE = 'deleteContentForward';
const useMask = (inputRef, _ref) => {
  let {
    onChange,
    onInput,
    maskOptions
  } = _ref;
  const applyMask = react.useCallback((event, inputValue) => {
    let cursor = 0;
    const result = [];
    const newValue = maskOptions.preProcess ? maskOptions.preProcess(inputValue) : inputValue;
    const isDelete = (event === null || event === void 0 ? void 0 : event.inputType) === BACKSPACE || (event === null || event === void 0 ? void 0 : event.inputType) === DELETE;
    for (let i = 0; i < maskOptions.mask.length; i += 1) {
      var _maskOptions$tokens$m;
      const maskChar = maskOptions.mask[i];
      if (cursor >= newValue.length) {
        if (maskOptions.eager && !maskOptions.tokens[maskChar] && !isDelete) {
          result.push(maskChar);
        }
        break;
      }
      if ((_maskOptions$tokens$m = maskOptions.tokens[maskChar]) !== null && _maskOptions$tokens$m !== void 0 && _maskOptions$tokens$m.multiple || maskOptions.tokens[maskChar]) {
        while (cursor < newValue.length) {
          const match = newValue[cursor].match(maskOptions.tokens[maskChar].pattern);
          if (match) {
            result.push(match[0]);
            cursor += 1;
            if (!maskOptions.tokens[maskChar].multiple) break;
          } else {
            if (maskOptions.tokens[maskChar].multiple && newValue[cursor] === maskOptions.mask[i + 1]) break;
            cursor += 1;
          }
        }
      } else {
        if (isDelete && newValue.length === i) {
          break;
        }
        if (!maskOptions.eager && maskChar !== newValue[cursor]) {
          break;
        }
        if (maskChar === newValue[cursor]) cursor += 1;
        result.push(maskChar);
      }
    }
    let maskedValue = result.join('');
    if (maskOptions.postProcess) maskedValue = maskOptions.postProcess(maskedValue);
    return maskedValue;
  }, [maskOptions]);
  const changeInputValue = (input, value) => {
    const objectPrototype = Object.getPrototypeOf(input);
    const {
      set: prototypeValueSetter
    } = Object.getOwnPropertyDescriptor(objectPrototype, 'value') || {};
    prototypeValueSetter === null || prototypeValueSetter === void 0 || prototypeValueSetter.call(input, value);
  };
  const handleInputChange = react.useCallback(event => {
    var _inputRef$current, _event$target;
    const inputElement = inputRef === null || inputRef === void 0 || (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.querySelector('input');
    let cursorPosition = (inputElement === null || inputElement === void 0 ? void 0 : inputElement.selectionStart) || 0;
    const value = ((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) || '';
    const maskedValue = applyMask(event, value);
    inputElement.value = undefined;
    event.target.value = undefined;
    changeInputValue(inputElement, maskedValue);
    if (typeof onInput === 'function') {
      onInput(event);
    }
    if (typeof onChange === 'function') {
      onChange(event);
    }
    const diffLength = maskedValue.length - value.length;
    cursorPosition += diffLength < 0 ? 0 : diffLength;
    if (inputElement) {
      inputElement.selectionStart = cursorPosition;
      inputElement.selectionEnd = cursorPosition;
    }
  }, [onChange, onInput, applyMask, inputRef]);
  react.useEffect(() => {
    var _inputRef$current2;
    if (!inputRef.current) return;
    const inputElement = inputRef === null || inputRef === void 0 || (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.querySelector('input');
    const inputValue = inputElement === null || inputElement === void 0 ? void 0 : inputElement.value;
    if (inputElement) inputElement.addEventListener('input', handleInputChange);
    if (inputValue) {
      const maskedValue = applyMask(undefined, inputValue);
      changeInputValue(inputElement, maskedValue);
      const changeEvent = new Event('change', {
        bubbles: true
      });
      inputElement.dispatchEvent(changeEvent);
      const isInlineEdit = Array.from(inputRef.current.classList).some(className => className.includes('inline-edit'));
      if (isInlineEdit) {
        var _inputRef$current3;
        const inlineEditParagraph = inputRef === null || inputRef === void 0 || (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.querySelector('p');
        if (inlineEditParagraph) {
          inlineEditParagraph.textContent = maskedValue;
        }
      }
    }
    return () => {
      if (inputElement) inputElement.removeEventListener('input', handleInputChange);
    };
  }, [inputRef, handleInputChange]);
};
module.exports = useMask;
